import { useAppSelector } from '@/redux/hooks'
import classnames from 'classnames/bind'

// Components
import { StateHandler } from '@/components/pages/livemallclub/Explore/components/Preferences/components/SearchResults/components/_shared/StateHandler'
import LiveItem from '@/components/shared/livemallclub/LiveItem'

// Libs
import { MemberTimelineLiveResponseType, useMemberLivesQuery } from '../../../hooks/useMemberLivesQuery'
import { useProfileData } from '../../../hooks/useProfileData'
import { useProfileContext } from '../../../reducer'

// Constants
import { ROLE_TYPE } from '@/constants/roleType'
import { FeedMetaType, FeedType } from '@/types/feed'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const formatRooms = (
  pageData: MemberTimelineLiveResponseType[] | undefined,
  memberInfo: {
    name?: string
    headshotUrl: string | null
    memberId?: string
  },
): FeedType['meta'][] => {
  if (!pageData || pageData.length === 0) return []
  const feeds = pageData
    .flatMap((page) => page)
    .flatMap((feed) => feed.feeds)
    .filter((item) => !!item)
  return feeds.map((room) => ({
    roomId: room?.meta.roomId || '',
    liveType: room?.meta.liveType || 0,
    time: room?.meta.liveTime || room?.meta.startTime,
    coverPhotoUrl: room?.meta.coverPhotoUrl || '',
    title: room?.meta.title || '',
    description: room?.meta.roomDesc || '',
    isFavorite: room?.meta.isFavorite || false,
    ownerName: memberInfo.name || '',
    ownerMemberInfoId: memberInfo.memberId || '',
    countryCode: '',
    roomDesc: room?.meta.roomDesc || '',
    preferencesTag: [],
    startTime: room?.meta.startTime || '',
    liveTime: room?.meta.liveTime || '',
    ownerAvatarUrl: memberInfo.headshotUrl || '',
    liveCloseTime: room?.meta.liveCloseTime || '',
    dummyViews: room?.meta.dummyViews || 0,
    liveSourceType: 0,
    valid: room?.meta.valid || false,
    isVip: room?.meta.isVip || false,
  }))
}

const MemberLives = ({ type }: { type?: 'live' | 'vip' }) => {
  const { memberIdToQuery, name, headshotUrl } = useProfileData()
  const { memberData } = useAppSelector((state) => state.member)
  const { isManageMode } = useProfileContext().state
  const isMerchantOwnProfile = memberData.memberInfoId === memberIdToQuery && memberData.roles?.includes(ROLE_TYPE.MERCHANT)
  const { data: roomsRawData, InfiniteScrollComponent, query } = useMemberLivesQuery({ memberInfoId: memberIdToQuery, type: type || 'live' })
  const rooms = formatRooms(roomsRawData, { name, headshotUrl, memberId: memberIdToQuery })
  const displayedRooms: FeedMetaType[] = isMerchantOwnProfile && !isManageMode ? rooms.filter((room) => room.valid) : rooms
  const isEmpty = rooms.length === 0
  const isLoading = (query.isLoading || query.isRefetching) && !query.isFetchingNextPage

  return (
    <StateHandler isFetching={isLoading} isEmpty={isEmpty} type='profile_lives' position='absolute'>
      <InfiniteScrollComponent>
        <div className={cx('member-item-list')}>
          {displayedRooms.map((room) => (
            <LiveItem key={room.roomId} showVisibilityMask={isManageMode} isProfile {...room} />
          ))}
        </div>
      </InfiniteScrollComponent>
    </StateHandler>
  )
}

export default MemberLives
